import { render, staticRenderFns } from "./mySjkh.vue?vue&type=template&id=5dc87133&scoped=true"
import script from "./mySjkh.vue?vue&type=script&lang=js"
export * from "./mySjkh.vue?vue&type=script&lang=js"
import style0 from "./mySjkh.vue?vue&type=style&index=0&id=5dc87133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc87133",
  null
  
)

export default component.exports